import { getGlobals } from "src/consts/globals";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { useCertificateBoxContext } from "../context";
import { IndicatorShell } from "./indicator-shell/indicator-shell";

const CERTIFICATE_BOX_INVESTED_CAPITAL_TEST_ID = "certificate-box-invested-capital";

export const CBInvestedCapital = () => {
    const { data } = useCertificateBoxContext();
    const { formatNumber } = useNumberFormatter();

    const totalInvestments = `${getGlobals().currency} ${
        data.keyFigures.totalInvestments.ranking.value ? formatNumber(data.keyFigures.totalInvestments.ranking.value) : 0
    }`;

    const { label } = data.keyFigures.totalInvestments.ranking;

    return (
        <IndicatorShell
            dataTestId={CERTIFICATE_BOX_INVESTED_CAPITAL_TEST_ID}
            tooltip={data.keyFigures.totalInvestments.tooltip!}
            indicatorName={label}
            indicatorValue={totalInvestments}
        />
    );
};
